<script setup lang="ts">
import { computed, useSlots } from 'vue'

const props = defineProps<{
  content: string
}>()

const slots = useSlots()
const currentContent = computed(() => props.content)
</script>

<template>
  <div class="content-view">
    <template v-for="(_, name) in slots">
      <transition name="fade" mode="out-in">
        <div :class="['content-view-item', name, { hidden: name != currentContent }]" v-show="name == currentContent">
          <slot :name="name"></slot>
        </div>
      </transition>
    </template>
  </div>
</template>

<style scoped>
.content-view {
  width: 100%;
  height: 100%;
}

.content-view-item {
  position: absolute;
  width: inherit;
  height: inherit;
}
</style>
